/**
 * Stripe error code translations to Portuguese
 */
export const stripeErrorMessages: Record<string, string> = {
  // Card errors
  'card_declined': 'Cartão recusado pela operadora',
  'insufficient_funds': 'Saldo insuficiente no cartão',
  'expired_card': 'Cartão expirado',
  'incorrect_cvc': 'Código de segurança (CVV) incorreto',
  'incorrect_number': 'Número do cartão incorreto',
  'invalid_cvc': 'Código de segurança inválido',
  'invalid_expiry_month': 'Mês de validade inválido',
  'invalid_expiry_year': 'Ano de validade inválido',
  'invalid_number': 'Número do cartão inválido',
  'processing_error': 'Erro no processamento - tente novamente',
  'card_not_supported': 'Este cartão não é suportado',
  'currency_not_supported': 'Moeda não suportada por este cartão',
  'duplicate_transaction': 'Transação duplicada detectada',
  'fraudulent': 'Transação marcada como fraudulenta',
  'generic_decline': 'Cartão recusado - entre em contato com o banco',
  'incorrect_pin': 'PIN incorreto',
  'incorrect_zip': 'CEP incorreto',
  'invalid_account': 'Conta inválida',
  'invalid_amount': 'Valor inválido',
  'invalid_pin': 'PIN inválido',
  'issuer_not_available': 'Emissor do cartão indisponível',
  'lost_card': 'Cartão reportado como perdido',
  'merchant_blacklist': 'Cartão bloqueado para esta loja',
  'new_account_information_available': 'Dados do cartão atualizados - tente novamente',
  'no_action_taken': 'Nenhuma ação tomada pelo banco',
  'not_permitted': 'Operação não permitida',
  'offline_pin_required': 'PIN offline necessário',
  'online_or_offline_pin_required': 'PIN necessário',
  'pickup_card': 'Cartão deve ser retido',
  'pin_try_exceeded': 'Tentativas de PIN excedidas',
  'reenter_transaction': 'Refazer a transação',
  'restricted_card': 'Cartão com restrição',
  'revocation_of_all_authorizations': 'Autorizações revogadas',
  'revocation_of_authorization': 'Autorização revogada',
  'security_violation': 'Violação de segurança',
  'service_not_allowed': 'Serviço não permitido',
  'stolen_card': 'Cartão reportado como roubado',
  'stop_payment_order': 'Ordem de suspensão de pagamento',
  'testmode_decline': 'Cartão de teste recusado',
  'transaction_not_allowed': 'Transação não permitida',
  'try_again_later': 'Tente novamente mais tarde',
  'withdrawal_count_limit_exceeded': 'Limite de saques excedido',
  'do_not_honor': 'Cartão recusado - entre em contato com o banco',
  'call_issuer': 'Entre em contato com o emissor do cartão',
  'card_velocity_exceeded': 'Limite de transações do cartão excedido',
  'approve_with_id': 'Tente novamente',
  'issuer_decline': 'Recusado pelo emissor do cartão',
  'live_mode_test_card': 'Cartão de teste usado em modo produção',
  
  // Payment method errors
  'payment_method_not_available': 'Método de pagamento não disponível',
  'payment_intent_authentication_failure': 'Falha na autenticação do pagamento',
  'authentication_required': 'Autenticação necessária (3D Secure)',
  
  // Customer errors
  'customer_not_found': 'Cliente não encontrado no Stripe',
  'no_payment_method': 'Nenhum método de pagamento cadastrado',
  
  // Generic
  'rate_limit': 'Muitas tentativas - aguarde alguns minutos',
  'api_connection_error': 'Erro de conexão com o Stripe',
  'api_error': 'Erro interno do Stripe',
  'invalid_request_error': 'Requisição inválida',
};

/**
 * Get translated error message from Stripe error code
 */
export function getStripeErrorMessage(errorCode: string | null | undefined, fallbackMessage?: string): string {
  if (!errorCode) {
    return fallbackMessage || 'Erro desconhecido no pagamento';
  }
  
  // Normalize error code (lowercase, replace spaces)
  const normalizedCode = errorCode.toLowerCase().replace(/\s+/g, '_');
  
  // Check exact match
  if (stripeErrorMessages[normalizedCode]) {
    return stripeErrorMessages[normalizedCode];
  }
  
  // Check if error code is contained in any key
  for (const [key, value] of Object.entries(stripeErrorMessages)) {
    if (normalizedCode.includes(key) || key.includes(normalizedCode)) {
      return value;
    }
  }
  
  // Return fallback or original message
  return fallbackMessage || errorCode;
}
